// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hootsuite-box-container {
  background-color: #fff;
  width: 800px;
  border-radius: 20px;
  padding: 20px;
}
.hootsuite-box-container h2 {
  font-size: 32px;
  font-weight: 600;
  letter-spacing: -0.5px;
  margin-bottom: 20px;
}
.hootsuite-box-container .ql-editor {
  min-height: 200px;
}
.hootsuite-box-container .hootsuite-box-container-buttons {
  display: flex;
  margin: 10px 0;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
}
.hootsuite-box-container .hootsuite-box-button {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/HootSuiteBox/hootsuitebox.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AAGE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AADJ;AAIE;EACE,iBAAA;AAFJ","sourcesContent":[".hootsuite-box-container {\n  background-color: #fff;\n  width: 800px;\n  border-radius: 20px;\n  padding: 20px;\n\n  h2 {\n    font-size: 32px;\n    font-weight: 600;\n    letter-spacing: -0.5px;\n    margin-bottom: 20px;\n  }\n\n  .ql-editor {\n    min-height: 200px;\n  }\n\n  .hootsuite-box-container-buttons {\n    display: flex;\n    margin: 10px 0;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n  }\n\n  .hootsuite-box-button {\n    margin-left: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
